import { KEYS } from 'game/constants/SceneConstants';
import { SceneBase } from '@jollywise/jollygoodgame';
import { FONT_BASE } from 'game/constants/AppFonts';
import { trackGameStart } from 'game/utils/GaTracking';

export class Intro extends SceneBase {
  constructor() {
    super({ key: KEYS.Intro, active: false });
  }
  create() {
    super.create();
    this.game._scenario.getRandomScenario();

    this.setBackgroundColour(0xc9e3e8);
    this.bg = this.add.image(0, 0, 'backgrounds', 'background_scenario').setOrigin(0);

    this.game.hud.setState('GAME_INTRO');

    this.currentSpeechBubble = 1;

    this.addPlaceholderUI();
    this.game.hud.events.on('CONTINUE_INTRO', this.showNextPanel, this);

    trackGameStart({ play_count: this.game._player.timesPlayedGame });
  }

  showNextPanel() {
    if (this.currentSpeechBubble < 2) {
      this.currentSpeechBubble++;
      this.introImage.setTexture('ui', `intro_${this.currentSpeechBubble}`);

      return;
    }

    this.endIntro();
  }

  endIntro() {
    this.game.startGame();
  }

  addPlaceholderUI() {
    this.introImage = this.add
      .sprite(840, this.game.defaultHeight, 'ui', `intro_${this.currentSpeechBubble}`)
      .setOrigin(0.5, 1);

    this.add.sprite(840, 180, 'ui', `intro_time`).setOrigin(0.5, 0);

    this.add.image(0, 0, 'backgrounds', 'background_header_fail').setOrigin(0);

    this.add
      .text(840, 60, 'The negotiation begins...', {
        fontFamily: FONT_BASE.CALIBRE_BOLD,
        fontSize: '68px',
        color: '#ffffff',
      })
      .setOrigin(0.5);
  }

  shutdown() {
    this.game.hud.events.off('CONTINUE_INTRO', this.showNextPanel, this);
  }
}
